module.exports = __webpack_public_path__ + "img/icon-nav-arrow-right.1a0f00d0.svg";